<template>
  <label
    :for="id"
    class="flex items-center justify-center p-2 cursor-pointer border rounded-lg h-9 w-16 font-body text-sm font-normal select-none transition-colors"
    :class="
      model === value
        ? 'text-n-0 bg-[--primary-color] border-[--primary-color]'
        : 'text-n-300 border-n-300'
    "
  >
    <input
      type="radio"
      v-model="model"
      :id="id"
      :name="name"
      :value="value"
      class="hidden"
    />
    <slot />
  </label>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  name: string
  value: string | number | null
}>()

defineEmits(['clickOption'])

const model = defineModel<string | number | null>()

const id = computed(() => `${props.name}-${props.value}`)
</script>
